import { useEffect } from "react";
import { useGetUnreadCountQuery } from "@/store/api/conversationsApi";
import { setUnreadCount } from "@/store/slice/conversationsUnreadSlice";
import { useAppDispatch } from "./useAppDispatch";
import { useAppSelector } from "./useAppSelector";

export const useConversationsUnread = () => {
  const dispatch = useAppDispatch();
  const userUid = useAppSelector((state) => state.auth.user?.uid);
  const { data, isSuccess, isError, fulfilledTimeStamp } = useGetUnreadCountQuery(
    userUid ?? "guest",
    {
      skip: !userUid,
      refetchOnMountOrArgChange: true,
      pollingInterval: 15000,
      skipPollingIfUnfocused: true,
    }
  );
  const { count, frozenCount } = useAppSelector((state) => state.conversationsUnread);

  useEffect(() => {
    if (typeof data?.count === "number") dispatch(setUnreadCount(data.count));
  }, [data?.count, fulfilledTimeStamp, dispatch]);

  return {
    count,
    frozenCount,
    serverCount: data?.count ?? null,
    isReady: isSuccess || isError,
  };
};
